export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
    visible: that.multiple
  },
  {
    field: 'radio',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'radio',
    visible: !that.multiple
  },
  {
    title: that.$l('table_label_hxPreOrderNo') || '采购单号',
    field: 'hxPreOrderNo',
    minWidth: 150,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  // {
  //   title: that.$l('table_label_hxPreOrderStatus') || '单据状态',
  //   field: 'hxPreOrderStatus',
  //   width: 100,
  //   align: 'center',
  //   showHeaderOverflow: true,
  //   slots: { default: 'status' },
  // },
  {
    title: that.$l('table_label_PreOrderDate') || '下单日期',
    field: 'preOrderDate',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_salesPerson') || '业务开发',
    field: 'salesPersonName',
    minWidth: 150,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_buyer') || '负责采购',
    field: 'buyerName',
    minWidth: 150,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_skuSalesChannel') || '产品类型',
    field: 'hxSkuSalesChannel',
    minWidth: 100,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'hxSkuSalesChannel' },
  },
  {
    title: that.$l('table_label_orderCust') || '订单客户',
    field: 'custName',
    minWidth: 180,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_totalQty') || '采购数量',
    field: 'totalQty',
    minWidth: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_totalAmount') || '采购金额',
    field: 'totalAmount',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ row }) => {
      const { totalAmount, v_currencyUnit } = row
      return [that.format(totalAmount) || '0', v_currencyUnit].join(' ')
    },
  },
  {
    title: that.$l('table_label_deliveryDate') || '最早交期',
    field: 'deliveryDate',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_jdOrderType') || '京东订单类型',
    field: 'jdOrderType',
    minWidth: 150,
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_jdGoodsType') || '京东产品类型',
    field: 'jdGoodsType',
    minWidth: 150,
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_jdPcm') || '京东采控经理',
    field: 'jdPcm',
    minWidth: 150,
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_jdPm') || '京东产品经理',
    field: 'jdPm',
    minWidth: 150,
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_remark') || '备注说明',
    field: 'remark',
    minWidth: 300,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_createBy') || '创建人',
    field: 'createBy',
    minWidth: 170,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    slots: { default: 'createInfo' },
  },
  {
    title: that.$l('table_label_modifyBy') || '修改人',
    field: 'modifyBy',
    minWidth: 170,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    slots: { default: 'modifyInfo' },
  },
  {
    title: that.$l('table_label_submitBy') || '提交人',
    field: 'submitBy',
    minWidth: 170,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    slots: { default: 'submitInfo' },
  },
  {
    title: that.$l('table_label_reviewBy') || '审核人',
    field: 'reviewBy',
    minWidth: 170,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    slots: { default: 'reviewInfo' },
  },
]
